// Marker congestion level thresholds for the number of markers
// const CongestionLevelThresholds = [0, 3, 5] // Dev mode thresholds (because we're probably rendering far fewer markers)
const CongestionLevelThresholds = [0, 400, 1000]

export default class MarkerCongestionCalculator {

    constructor(markersSize) {
        this.markersSize = markersSize;
        this.congestionLevel = this.getCongestionLevel();
    }

    getCongestionLevel() {
        if (this.markersSize >= CongestionLevelThresholds[2]) {
            return 'max'
        } else if (this.markersSize >= CongestionLevelThresholds[1]) {
            return 'mid'
        } else if (this.markersSize >= CongestionLevelThresholds[0]) {
            return 'min'
        }
    }

}